var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('span',[_c('router-link',{staticClass:"btn",class:{
      'btn-warning':
        _vm.sysTags.includes('subscription_level:TRIAL') ||
        _vm.sysTags.includes('subscription_level:FREE'),
      'btn-info':
        !_vm.sysTags.includes('subscription_level:FREE') &&
        !_vm.sysTags.includes('subscription_level:TRIAL'),
    },attrs:{"to":{ name: 'billing-info', params: { subId: 'current' } }}},[_c('i',{staticClass:"glyphicon glyphicon-upload"}),_vm._v(" "+_vm._s(_vm.text)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }